// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5351) return "static/chunks/5351-427ed4790faa1300.js";
	if (chunkId === 3448) return "static/chunks/3448-d0ca2b6f5d208306.js";
	if (chunkId === 4580) return "static/chunks/4580-d2cf683ce0189d58.js";
	if (chunkId === 4957) return "static/chunks/4957-a41accf66b8141fe.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2440":"datadogProfiler","3581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"34":"4ca31c1b96ce9683","451":"03df397306819887","1257":"179c85694d5c68ba","1376":"b87fb4a712655e36","1798":"ff3f2a9bab167936","2440":"eb21145d7aa0b612","3581":"cfc457f6422db9d7","5781":"f2ad8ccf41b3ffa9"}[chunkId] + ".js";
};